import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-loading-skeleton/dist/skeleton.css'
import App from './App';
import reportWebVitals from './reportWebVitals';

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: 'https://3af3712fb94d46cbbb29171434b9b2d1@o1123730.ingest.sentry.io/6170042',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

import { AuthProvider } from '@/contexts/AuthContext';
import { LayoutProvider } from '@/contexts/LayoutContext';
import { ModalProvider } from '@/contexts/ModalContext';
import { StakeProvider } from '@/contexts/StakeContext';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/database';
import 'firebase/compat/firestore';

import { createStore } from "redux";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { createFirestoreInstance } from "redux-firestore";
import { rootReducer } from "./store/reducers";
import { BrowserRouter } from "react-router-dom";
import { IntercomProvider } from 'react-use-intercom'
const INTERCOM_APP_ID = 'sva9g4az';

const firebaseConfig = {
  apiKey: "AIzaSyAVSzW-o3-0hgTgsNxlXX5XkdsAlt8Up10",
  authDomain: "duelarenagg-b7872.firebaseapp.com",
  projectId: "duelarenagg-b7872",
  storageBucket: "duelarenagg-b7872.appspot.com",
  messagingSenderId: "191833294978",
  appId: "1:191833294978:web:6be3284036deecda5a4c9b"
};

const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: false,
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

const initialState = {};
const store = createStore(rootReducer, initialState);

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};

export { firebase }

ReactDOM.render(
  <React.StrictMode>
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
          <BrowserRouter>
            <AuthProvider>
              <LayoutProvider>
                <StakeProvider>
                  <ModalProvider>
                    <App />
                  </ModalProvider>
                </StakeProvider>
              </LayoutProvider>
            </AuthProvider>
          </BrowserRouter>
        </ReactReduxFirebaseProvider>
      </Provider>
    </IntercomProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
